import React, { useState, forwardRef } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { MDBInput } from "mdb-react-ui-kit";
import { FaChevronLeft, FaChevronRight, FaCalendarAlt } from "react-icons/fa";
import { getYear, getMonth } from "date-fns";
import PropTypes from "prop-types";

const CustomInput = forwardRef(({ value, onClick, placeholder }, ref) => (
    <MDBInput
        label="Select Date"
        placeholder={placeholder}
        value={value}
        onClick={onClick}
        ref={ref}
        icon={<FaCalendarAlt />}
    />
));

const DatePickerComponent = ({
    selectedDate,
    onDateChange,
    label,
    minDate,
    maxDate,
}) => {
    const initialDate = selectedDate || null;
    const [startDate, setStartDate] = useState(initialDate);

    const range = (start, end, step = 1) => {
        let output = [];
        for (let i = start; i <= end; i += step) {
            output.push(i);
        }
        return output;
    };

    const years = range(1990, getYear(new Date()) + 1, 1);
    const months = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
    ];

    const handleDateChange = (date) => {
        setStartDate(date);
        if (onDateChange) {
            onDateChange(date);
        }
    };

    const placeholderText = "dd/mm/yyyy";

    return (
        <DatePicker
            dateFormat="dd/MM/yyyy"
            renderCustomHeader={({
                date,
                changeYear,
                changeMonth,
                decreaseMonth,
                increaseMonth,
                prevMonthButtonDisabled,
                nextMonthButtonDisabled,
            }) => (
                <div className="d-flex justify-content-center align-items-center mb-2">
                    <button
                        className="btn btn-link p-0"
                        onClick={decreaseMonth}
                        disabled={prevMonthButtonDisabled}
                    >
                        <FaChevronLeft />
                    </button>
                    <select
                        className="form-select mx-1"
                        value={getYear(date)}
                        onChange={({ target: { value } }) => changeYear(value)}
                    >
                        {years.map((option) => (
                            <option key={option} value={option}>
                                {option}
                            </option>
                        ))}
                    </select>

                    <select
                        className="form-select mx-1"
                        value={months[getMonth(date)]}
                        onChange={({ target: { value } }) =>
                            changeMonth(months.indexOf(value))
                        }
                    >
                        {months.map((option) => (
                            <option key={option} value={option}>
                                {option}
                            </option>
                        ))}
                    </select>

                    <button
                        className="btn btn-link p-0"
                        onClick={increaseMonth}
                        disabled={nextMonthButtonDisabled}
                    >
                        <FaChevronRight />
                    </button>
                </div>
            )}
            selected={startDate}
            onChange={handleDateChange}
            minDate={minDate}
            maxDate={maxDate}
            customInput={
                <CustomInput
                    placeholder={placeholderText}
                    value={startDate ? startDate.toLocaleDateString() : ""}
                />
            }
            
        />
    );
};

DatePickerComponent.propTypes = {
    selectedDate: PropTypes.instanceOf(Date),
    onDateChange: PropTypes.func, // Making onDateChange optional
    label: PropTypes.string,
    minDate: PropTypes.instanceOf(Date),
    maxDate: PropTypes.instanceOf(Date),
};

DatePickerComponent.defaultProps = {
    selectedDate: null,
    label: "Select Date",
    minDate: null,
    maxDate: null,
};

export default DatePickerComponent;
